import { clearError, startAction } from "context/userSlice";
import { axiosPOSTLogin, axiosPRELogin } from "./axios";
import { errorHandler } from "./errorHandler";

import { BACKEND_ENDPOINTS } from "Theconstants";

export const visitsAPI = {
  saveVisit: async function () {
    try {
      await axiosPRELogin.post<void>(BACKEND_ENDPOINTS.VISITS);
    } catch (error) {
      //error handler
      console.log(error, "GEOIP");
    }
  },
  //VER SI USO LOADING GRAL O INDIVIDUAL
  getVisits: async function (dispatch, page) {
    dispatch(startAction());
    try {
      //NO HAY GENERAL STATE ACA, lo hacemos x component
      const { data } = await axiosPOSTLogin.get<{
        visits: IVisit[];
        totalPaginatedPages: number;
        totalVisits: number;
      }>(`${BACKEND_ENDPOINTS.VISITS}?page=${page}`);
      dispatch(clearError());
      console.log(data, 666);
      return Promise.resolve(data);
    } catch (error) {
      errorHandler(error, dispatch, "GET ALL VISITS");
      return Promise.reject();
    }
  },
};
